import { useFlags } from 'launchdarkly-react-client-sdk';

/**
 * Get DevEx feature flags.
 */
export const useClientFlags = () => {
  const flags = useFlags();

  const getFlag = (key: string) => !!flags[key];

  return {
    studyReveal: getFlag('bakunawaDevexSurveyRevealQ324'),
    slackTargeting: window.dx.user?.company.isEmp,
    viewOpenSurveyResults: getFlag('bakunawaDevexCanViewOpenSurveyResultsQ125'),
    scheduledCloseReminders: getFlag('bakunawaDevexScheduledClosedRemindersQ225'),
    msTeamsTargeting: getFlag('akhlutMsTeamsAlertingQ125'),
    skippableQuestions: getFlag('bakunawaDevexSkippableQuestionsQ325'),
    useEmpSlackUsers: getFlag('sireniaDevexQ126SlackUsersSync'),
    showInactiveDevExTeams: getFlag('sireniaShowInactiveDevexTeamsQ126'),
  };
};
